import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const PrimaryButton: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Button {...rest} variant="contained" color="primary">
    {children}
  </Button>
);

export default PrimaryButton;
